/**
 * Find disease name from its id
 * @param {string} diseaseId disease id
 * @param {Array} diseaseList diseases Array
 * @returns {string} disease name
 */
export const getDiseaseName = (diseaseId, diseaseList) => {
  if (!diseaseId || !diseaseList || diseaseList.length === 0)
    return diseaseId || "";

  const disease = diseaseList.find((d) => d.id === diseaseId);
  return disease?.name || diseaseId;
};

export const isValidFieldNotePosition = (position) =>
  Array.isArray(position) &&
  position.length === 2 &&
  position.every(
    (coordinate) =>
      coordinate !== null &&
      coordinate !== "" &&
      Number.isFinite(Number(coordinate)),
  );
